import { api } from "../api";
import moment from "moment";

export const planUsage = api.injectEndpoints({
    endpoints: (builder) => ({ 
        imageUsage: builder.query({
            query: ({ startDate, endDate }) => {
                const params = new URLSearchParams();

                if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                    params.append('startDate', startDate);
                    params.append('endDate', endDate);
                }

                return {
                    url: `ai/image/api-usages${params.toString() ? `?${params.toString()}` : ''}`,
                };
            },
            transformResponse: (response, meta, arg) => response.data,
        }), 
        videoUsage: builder.query({
            query: ({ startDate, endDate }) => {
                const params = new URLSearchParams();

                if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                    params.append('startDate', startDate);
                    params.append('endDate', endDate);
                }

                return {
                    url: `ai/video/api-usages${params.toString() ? `?${params.toString()}` : ''}`,
                };
            },
            transformResponse: (response, meta, arg) => response.data,
        }),
        campaignsUsage: builder.query({
            query: ({ startDate, endDate }) => {
                const params = new URLSearchParams();

                if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                    params.append('startDate', startDate);
                    params.append('endDate', endDate);
                }

                return {
                    url: `campaigns/usages${params.toString() ? `?${params.toString()}` : ''}`,
                };
            },
            transformResponse: (response, meta, arg) => response.data,
        }),  
        adsetsUsage: builder.query({
            query: ({ startDate, endDate }) => {
                const params = new URLSearchParams();

                if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                    params.append('startDate', startDate);
                    params.append('endDate', endDate);
                }

                return {
                    url: `adsets/usages${params.toString() ? `?${params.toString()}` : ''}`,
                };
            },
            transformResponse: (response, meta, arg) => response.data,
        }),  
        adsUsage: builder.query({
            query: ({ startDate, endDate }) => {
                const params = new URLSearchParams();

                if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                    params.append('startDate', startDate);
                    params.append('endDate', endDate);
                }

                return {
                    url: `ads/usages${params.toString() ? `?${params.toString()}` : ''}`,
                };
            },
            transformResponse: (response, meta, arg) => response.data,
        }),  
        imageAndVideoUsage: builder.query({
            query: ({ interval}) => {
            
                return {
                    url: `ai/usage?interval=${interval}`,
                };
            },
            transformResponse: (response, meta, arg) => response.data,
        }), 
    }),
});

export const { useImageUsageQuery, useVideoUsageQuery, useImageAndVideoUsageQuery, useCampaignsUsageQuery, useAdsetsUsageQuery, useAdsUsageQuery } = planUsage;
